module.exports = __webpack_public_path__ + "static/media/add.0b5b16f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/add.svg
// module id = 2082
// module chunks = 7